module.exports = __webpack_public_path__ + "static/media/sp_menu_2_20230419.84526c0a.webp";